module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("img")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.upload($event.target.files)
      }
    }
  })]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": _vm.img,
      "frameborder": "0"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ffdb478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/User/UserImg.vue
// module id = 1407
// module chunks = 0